module.exports = __webpack_public_path__ + "img/icn_report_white.86f701fb.svg";